import { normalizeUpdateTasks } from '@griply/utils';
import { useMutation } from '@tanstack/react-query';
import { updateTasks } from 'shared/services/backend-api';
import { UpdateTask } from 'shared/types/task';

export const useUpdateTasksMutation = () =>
  useMutation({
    mutationFn: async (tasks: UpdateTask[]) =>
      updateTasks(normalizeUpdateTasks(tasks)),
  });
